import React, { FunctionComponent } from "react";

import { bemClassNames, TAB_INDEX_FOCUSABLE_TAB_SEQUENCE } from "@multiweb/reactUtils";
import { Role } from "@multiweb/uiShared/Role";
import { FlexGrow, Layout } from "../Layout";
import { Text, TextColor, WhiteSpace } from "../Text";
import { FakeComponentProps } from "../types";

export type LinkEditFakeComponentProps = {
    /** Text zobrazovaný v komponentě */
    value: string;
} & FakeComponentProps;

const classNames = bemClassNames("link-edit-fake-component");

export const LinkEditFakeComponent: FunctionComponent<LinkEditFakeComponentProps> = ({
    value,
    onClick,
    onKeyDown,
    label,
    title,
    disabled,
    valueTitle,
    isEditing,
    ariaLabelledBy,
}) => (
    <div
        className={classNames({ disabled: disabled || !isEditing })}
        tabIndex={TAB_INDEX_FOCUSABLE_TAB_SEQUENCE}
        role={Role.textBox}
        aria-disabled={disabled}
        aria-label={ariaLabelledBy ? undefined : label}
        aria-labelledby={ariaLabelledBy}
        {...{ title, onClick, onKeyDown }}
    >
        <Layout flexGrow={FlexGrow.one}>
            <Text color={TextColor.textPrimary} title={valueTitle} value={value} disabled={disabled || !isEditing} whiteSpace={WhiteSpace.nowrap} ellipsis={true}/>
        </Layout>
    </div>
);
